<template>
  <div style="height:100%">
    <div style="position:relative">
      <Spin fix v-if="loadingGroup">加载中..</Spin>
      <div style="margin:5px 0;">
        <div style="color:#ed3f14;font-size:14px;">请注意：因需记录项目应收款修改记录，请在所有包组中标确认后，查看项目应收款预计总金额正确后点击下面的“应收确认”按钮。否则项目应收款不会变更！</div>
        <div style="font-size:14px;">
          <span>当前项目应收款预计：<span style="color:#ed3f14;">{{receivables}}</span></span>
          <Button type="primary" size="small" style="margin-left:16px;" @click="receivablesConfirm">应收确认</Button>
          <Button type="primary" size="small" style="margin-left:16px;" @click="showSurvey=true">采购方信息表</Button>
        </div>
      </div>
      <Card v-for="group in groupList" :key="group.id" style="margin-top:5px;min-width:1100px;">
        <div slot="extra">
          <Button type="primary" size="small" @click="viewArmarium(group)" style="margin-right:5px;">医疗设备</Button>
          <Button type="primary" size="small" @click="qualifyConfirm(group)" style="margin-right:5px;">资格标中标</Button>
          <Button type="error" size="small" @click="groupFail(group)" style="margin-right:5px;">失败确认</Button>
          <Tooltip :content="group.failReasons" placement="left" v-if="group.failReasons">
            <span style="color:#ed4014">已失败（查看）</span>
          </Tooltip>
        </div>
        <span slot="title">包组{{group.groupNo}}：{{group.groupName}}<span style="color: #19be6b;" v-if="group.isBuyer">（采购人付款）</span></span>
        <Table :columns="bidCompanyColumns" :data="group.enrollList" style="min-width:1000px;"></Table>
      </Card>
    </div>
    <Modal v-model="groupVisible" title="失败确认">
      <div style="margin:10px;">失败包组：{{selectFailGroup.groupName}}</div>
      <Form :label-width="100">
        <FormItem required label="失败原因">
          <Select v-model="failValue.reason" style="width:200px;">
            <Option v-for="reason in failReasons" :value="reason.value">{{reason.label}}</Option>
          </Select>
        </FormItem>
        <FormItem required label="失败分类">
          <Select v-model="failValue.failType" style="width:200px;">
            <Option v-for="type in failTypes" :value="type.value">{{type.label}}</Option>
          </Select>
        </FormItem>
        <FormItem required label="项目失败原因">
          <Input v-model="failValue.remark" style="width:200px;"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="groupVisible=false">取消</Button>
        <Button type="primary" @click="confirmFail">确认</Button>
      </div>
    </Modal>
    <Modal v-model="showSurvey" title="采购方信息表" width="1000">
      <iframe :src="link" style="width:100%;height:400px;border:0"></iframe>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import userAjax from '@/lib/userAjax'
import sendMessage from '@/lib/message'

export default {
  name: 'groupConfirm',
  props: {
    projectData: {
      type: Object,
      required: true
    }
  },
  async created() {
    // await this.getGroup()
    this.getEnrollExt()
  },
  data() {
    return {
      groupList: [],
      bidCompanyColumns: [
        {
          title: '投标单位',
          render: (h, params) => {
            return h('div', params.row.abpEnroll.companyName)
          }
        },
        {
          title: '联系人',
          width: 90,
          render: (h, params) => {
            return h('div', params.row.abpEnroll.projectContact)
          }
        },
        {
          title: '联系方式',
          width: 125,
          render: (h, params) => {
            return h('div', params.row.abpEnroll.projectPhone)
          }
        },
        {
          title: '中标金额',
          width: 90,
          key: 'winAmount'
        },
        {
          title: '应收款',
          width: 90,
          key: 'receivable'
        },
        {
          title: '是否中标',
          width: 90,
          key: 'status',
          render: (h, params) => {
            let win = ''
            if (params.row.status) {
              win = '中标'
            }
            return h('div', win)
          }
        },
        {
          title: '操作',
          width: 360,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    // 清空旧数据
                    this.winMoney = ''
                    this.winBid(params.row)
                  }
                }
              }, '中标'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    // 清空旧数据
                    this.winFloatMoney = ''
                    this.winFloatBid(params.row)
                  }
                }
              }, '中标（下浮率）'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    // 清空旧数据
                    this.winMoney = ''
                    this.winPercentMoney = ''
                    this.winPercentBid(params.row)
                  }
                }
              }, '中标（百分比）'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.cancelBid(params.row)
                  }
                }
              }, '取消中标'),
            ])
          }
        }
      ],
      winMoney: '',
      winFloatMoney: '',
      winPercentMoney: '',
      groupVisible: false,
      selectFailGroup: '',
      failValue: {
        reason: '',
        failType: '',
        remark: ''
      },
      failTypes: [
        {
          value: '标前失败',
          label: '标前失败'
        },
        {
          value: '评标中失败',
          label: '评标中失败'
        },
      ],
      failReasons: [
        {
          value: '无投标单位报名',
          label: '无投标单位报名'
        },
        {
          value: '报名投标人不足法定家数',
          label: '报名投标人不足法定家数'
        },
        {
          value: '递交标书不足法定家数',
          label: '递交标书不足法定家数'
        },
        {
          value: '招标文件问题',
          label: '招标文件问题'
        },
        {
          value: '经评审合格投标人不足法定三家',
          label: '经评审合格投标人不足法定三家'
        },
      ],
      loadingGroup: false,
      showSurvey: false
    }
  },
  computed: {
    receivables() {
      return this.groupList.reduce((pre, cur) => {
        return pre + cur.groupReceivable
      }, 0)
    },
    link () {
      return `http://report.choicelink.cn:8095/WebReport/ReportServer?reportlet=cailian/满意度调查表/项目评委信息_添加.cpt&op=write&ProjectId=${this.projectData.id}`
    }
  },
  methods: {
    receivablesConfirm() {
      this.$Modal.confirm({
        title: '项目应收确认',
        content: '确认项目应收款正确无误',
        onOk: async () => {
          try {
            // 计算项目应收
            let rep = await ajax.post(requestUrls.ClProjectDb.SetProjectReceivable + `?projectid=${this.projectData.id}`)
            this.$Message.success('调整项目应收成功')
            if (rep.data.success && rep.data.result.inform) {
              // 通知负责人
              let noticeRep = await userAjax.get(requestUrls.UserRoleService.GetUserListByDistrictRoleAsync, {
                params: {
                  RoleName: '分公司负责人',
                  SelectDistrict: this.projectData.district
                }
              })

              let noticeUserList = ['洪志伟']
              noticeRep.data.result.forEach(item => {
                noticeUserList.push(item.fullName)
              })

              let messageParams = {
                appId: '1005',
                uniqueId: '',
                contentJson: {
                  title: `${this.projectData.district}-${this.projectData.projectFull}-${this.projectData.projectFull}-${this.projectData.projectName}`,
                  subTitle: '应收款调整幅度过大',
                  description: `项目应收款从${this.projectData.receivables}变为${rep.data.result.project.receivables}`,
                  url: '#'
                }
              }
              noticeUserList.forEach(item => {
                messageParams.uniqueId = item
                sendMessage('wechat', messageParams)
              })
            }
            
          } catch(err) {
            this.$Message.error('调整失败')
            console.error(err)
          }
        }
      })
    },
    // 获取附属表所有报名
    async getEnrollExt() {
      await this.getGroup()
      this.groupList = this.groupList.filter(group => {
        group.enrollList = []
        return group
      })
      let rep = await ajax.get(requestUrls.enroll.GetEnrollExt, {
        params: {
          pid: this.projectData.id
        }
      })
      if (rep.data.success) {
        this.sortEnrollExt(rep.data.result.items)
      }
    },
    sortEnrollExt(enrollExtList = []) {
      enrollExtList.forEach(enrollExt => {
        for (let i = 0; i < this.groupList.length; i++) {
          let group = this.groupList[i]
          if (group.id === enrollExt.groupId) {
            if (!enrollExt.abpEnroll.isDeleted && enrollExt.abpEnroll.status === '3') {
              group.enrollList.push(enrollExt)
            }
            break
          }
        }
      })
    },
    // 获取包组
    async getGroup() {
      let rep = await ajax.get(requestUrls.ClGroupDb.getPaged, {
        params: {
          filter: `projectId=="${this.projectData.id}"`,
          maxResultCount: 500,
          skipCount: 0
        }
      })
      if (rep.data.success) {
        // this.groupList = rep.data.result.items
        this.groupList = this.handleGroupList(rep.data.result.items)
      }
    },
    // 包组供应商分类
    // sortEnroll(enrollList = []) {
    //   this.groupList.forEach(group => {
    //     this.$set(group, 'enrollList', [])
    //     for (let i = 0; i < enrollList.length; i++) {
    //       if (enrollList[i].groupId === group.id) {
    //         group.enrollList.push(enrollList[i])
    //       }
    //     }
    //   })
    // },
    // 包组排序
    handleGroupList(groupList) {
      let orderList = []
      groupList.forEach(group => {
        group.failReasons = ''
        if (group.failCause || group.failType) {
          group.failCause = group.failCause ? group.failCause : '无'
          group.failType = group.failType ? group.failType : '无'
          group.failReasons = `原因：${group.failCause} | 分类：${group.failType}  `
        }
        this.$set(group, 'enrollList', [])
        let index = parseInt(group.groupNo) - 1
        orderList[index] = group
      })
      let orderResult = []
      // 去除空数据并记录第一个空的位置
      for (let i = 0; i < orderList.length; i++) {
        let item = orderList[i]
        if (item) {
          orderResult.push(item)
        }
      }
      return orderResult
    },
    winFloatBid(row) {
      this.$Modal.confirm({
        title: '下浮率中标',
        render: (h) => {
          return h('div', [
            h('div', {
              style: {
                margin: '5px 0'
              }
            }, `投标单位：${row.abpEnroll.companyName}`),
            h('span', '请输入中标下浮率：'),
            h('Input', {
              props: {
                value: this.winFloatMoney,
                autofocus: true,
              },
              style: {
                width: '150px'
              },
              on: {
                input: (val) => {
                  this.winFloatMoney = val
                }
              }
            }),
            h('span', '%')
          ])
        },
        onOk: async () => {
          if (this.winFloatMoney === '') {
            this.$Message.error('请输入中标下浮率')
            return
          }
          this.$Spin.show()
          try {
            let rep = await ajax.post(requestUrls.enroll.SetWinBid, {
              id: row.id,
              winLower: this.winFloatMoney
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('设置中标单位成功')
              // 刷新
              this.getEnrollExt()
              this.setProjectState(row.projectId)

            } else {
              this.$Message.error('设置中标失败')
            }
          } catch (err) {
            this.$Spin.hide()
            this.$Message.error('设置中标失败')
          }
        }
      })
    },
    winBid(row) {
      this.$Modal.confirm({
        title: '确认中标',
        render: (h) => {
          return h('div', [
            h('div', {
              style: {
                margin: '5px 0'
              }
            }, `投标单位：${row.abpEnroll.companyName}`),
            h('span', '请输入中标金额：'),
            h('Input', {
              props: {
                value: this.winMoney,
                autofocus: true,
              },
              style: {
                width: '150px'
              },
              on: {
                input: (val) => {
                  this.winMoney = val
                }
              }
            }),
          ])
        },
        onOk: async () => {
          if (this.winMoney === '') {
            this.$Message.error('请输入中标金额')
            return
          }
          this.$Spin.show()
          try {
            let rep = await ajax.post(requestUrls.enroll.SetWinBid, {
              id: row.id,
              winAmount: this.winMoney
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('设置中标单位成功')
              // 刷新
              this.getEnrollExt()
              this.setProjectState(row.projectId)

            } else {
              this.$Message.error('设置中标失败')
            }
          } catch (err) {
            this.$Spin.hide()
            this.$Message.error('设置中标失败')
          }
        }
      })
    },
    winPercentBid(row) {
      this.$Modal.confirm({
        title: '百分比中标',
        render: (h) => {
          return h('div', [
            h('div', {
              style: {
                margin: '5px 0',
                color: '#ed4014'
              }
            }, `包组服务费预算需要设定项目定额`),
            h('div', {
              style: {
                margin: '5px 0'
              }
            }, `投标单位：${row.abpEnroll.companyName}`),
            h('div', {
              style: {
                marginTop: '5px'
              }
            }, [
              h('span', '中标金额：'),
              h('Input', {
                props: {
                  value: this.winMoney,
                  autofocus: true,
                },
                style: {
                  width: '150px'
                },
                on: {
                  input: (val) => {
                    this.winMoney = val
                  }
                }
              }),
            ]),
            h('div', {
              style: {
                marginTop: '5px'
              }
            }, [
              h('span', '（包组服务费预算）百分比：'),
              h('Input', {
                props: {
                  value: this.winPercentMoney,
                  autofocus: true,
                },
                style: {
                  width: '150px'
                },
                on: {
                  input: (val) => {
                    this.winPercentMoney = val
                  }
                }
              }),
              h('span', '%'),
            ]),
          ])
        },
        onOk: async () => {
          if (this.winMoney === '') {
            this.$Message.error('请输入中标金额')
            return
          }
          if (this.winPercentMoney === '') {
            this.$Message.error('请输入服务费收取百分比')
            return
          }
          this.$Spin.show()
          try {
            let rep = await ajax.post(requestUrls.enroll.SetWinPercent, {
              id: row.id,
              winAmount: this.winMoney,
              winPercent: this.winPercentMoney,
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('设置中标单位成功')
              // 刷新
              this.getEnrollExt()
              this.setProjectState(row.projectId)

            } else {
              this.$Message.error('设置中标失败')
            }
          } catch (err) {
            this.$Spin.hide()
            this.$Message.error('设置中标失败')
          }
        }
      })
    },
    async setProjectState(projectId = 'noId') {
      await ajax.put(requestUrls.ClProjectDb.UpdateStatus, {
        id: projectId,
        projectState: '已开评标完'
      })
    },
    cancelBid(row) {
      this.$Modal.confirm({
        title: '取消中标',
        content: `确定取消投标单位中标：${row.abpEnroll.companyName}`,
        onOk: async () => {
          this.$Spin.show()
          try {
            let rep = await ajax.post(requestUrls.enroll.SetUndoWindBid + `?id=${row.id}`, )
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('操作成功')
              this.getEnrollExt()
            } else {
              this.$Message.error('操作失败')
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('操作失败')
          }
        }
      })
    },
    groupFail(group) {
      this.selectFailGroup = group
      this.groupVisible = true
    },
    async confirmFail() {
      if (this.failValue.reason === '') {
        this.$Message.error('请选择失败原因')
        return
      }
      if (this.failValue.failType === '') {
        this.$Message.error('请选择失败类型')
        return
      }
      if (this.failValue.remark === '') {
        this.$Message.error('请输入项目失败原因')
        return
      }
      this.$Spin.show()
      try {
        let rep = await ajax.post(requestUrls.ClGroupDb.SetGroupFail, {
          id: this.selectFailGroup.id,
          failCause: this.failValue.reason,
          failType: this.failValue.failType,
          comment: this.failValue.remark
        })
        this.$Spin.hide()
        if (rep.data.success) {
          this.groupVisible = false
          this.$Message.success('操作成功')
          // 刷新包组，清空数据
          this.getEnrollExt()
          this.failValue.reason = ''
          this.failValue.failType = ''
          this.failValue.remark = ''
        } else {
          this.$Message.error('操作失败')
        }
      } catch (err) {
        this.$Spin.hide()
        this.$Message.error('操作失败')
      }
    },
    qualifyConfirm(group) {
      this.$Modal.confirm({
        title: '资格标中标确认',
        content: '确认此包组资格标中标确认？',
        onOk: async () => {
          this.$Spin.show()
          try {
            let rep = await ajax.post(requestUrls.enroll.SetWinQualification + `?gid=${group.id}`)
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('确认成功')
            } else {
              this.$Message.error('确认失败')
            }
          } catch(err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('确认失败')
          }
        }
      })
    },
    viewArmarium(group) {
      let name = this.$store.state.session.user.name
      window.open(`${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2FMedical%2FMedical_main.cpt&op=write&NPID=${this.projectData.id}&BZID=${group.id}&User=${name}`)
    }
  },
}
</script>

<style lang="less" scoped>
</style>
